<h3>{{'dashboard.shareSimu.title.shortLabel' | translate}} : {{ simulation.text.shortLabel }}
    <app-tooltip text="{{'dashboard.shareSimu.title.summary' | translate}}"></app-tooltip> </h3>

<ng-container *ngIf="roles && roles.length">
    <mat-list class="share-list">
        <ng-container *ngFor="let role of roles">
            <mat-list-item class="role-option" [ngClass]="{selected: isRoleSelected(role)}">
                <span mat-line>{{'dashboard.shareSimu.role.shortLabel' | translate}} : {{ role.text.shortLabel }}</span>
                <button mat-icon-button (click)="onSelectRole(role)">
                    <mat-icon aria-label="checkbox">{{ isRoleSelected(role) ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                </button>
            </mat-list-item>

            <mat-list-item *ngFor="let user of role.users" class="user-option" [ngClass]="{selected: isUserSelected(user)}">
                <span mat-line>{{ user.username }}</span>
                <button mat-icon-button (click)="onSelectUser(user)">
                    <mat-icon aria-label="checkbox">{{ isUserSelected(user) ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                </button>
            </mat-list-item>
        </ng-container>
    </mat-list>

    <div class="actions">
        <button mat-raised-button color="accent" (click)="onShareSimu()"
            [disabled]="!selectedRoles.length && !selectedUsers.length">
            {{'dashboard.shareSimu.apply.shortLabel' | translate}}
        </button>
        <button mat-button (click)="onCancel()">
            {{'dashboard.shareSimu.cancel.shortLabel' | translate}}
        </button>
    </div>
</ng-container>

<mat-progress-bar
    *ngIf="!roles || isLoading"
    class="progress-bar"
    color="accent"
    mode="indeterminate">
</mat-progress-bar>
